var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
/* no local variables */
__p+='\n';
/* Template for rendering non-link tag that stands for skipped pages ... (ellipsis) in pagination */
__p+='\n<span class="page gap">&hellip;</span>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/pagination/gap.jst.ejs